import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
export var BrowserLoader = /*#__PURE__*/function (_React$PureComponent) {
  function BrowserLoader() {
    var _this;
    _classCallCheck(this, BrowserLoader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BrowserLoader, [].concat(args));
    _defineProperty(_this, "mounted", false);
    _defineProperty(_this, "state", {
      Browser: BrowserLoader.Browser
    });
    return _this;
  }
  _inherits(BrowserLoader, _React$PureComponent);
  return _createClass(BrowserLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function () {
      var _UNSAFE_componentWillMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, mediaClient, browserModule;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.state.Browser) {
                _context.next = 9;
                break;
              }
              _context.next = 3;
              return Promise.all([import( /* webpackChunkName: "@atlaskit-internal_media-client-react" */'@atlaskit/media-client-react'), import( /* webpackChunkName: "@atlaskit-internal_media-browser" */'./browser')]);
            case 3:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              mediaClient = _yield$Promise$all2[0];
              browserModule = _yield$Promise$all2[1];
              // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
              BrowserLoader.Browser = mediaClient.withMediaClient(browserModule.Browser);
              if (this.mounted) {
                this.setState({
                  Browser: BrowserLoader.Browser
                });
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function UNSAFE_componentWillMount() {
        return _UNSAFE_componentWillMount.apply(this, arguments);
      }
      return UNSAFE_componentWillMount;
    }()
  }, {
    key: "render",
    value: function render() {
      if (!this.state.Browser) {
        return null;
      }
      return /*#__PURE__*/React.createElement(this.state.Browser, this.props);
    }
  }]);
}(React.PureComponent);
_defineProperty(BrowserLoader, "displayName", 'AsyncBrowser');